import { useEffect, useState } from "react";
import ReactMarkdown from "react-markdown";
import Header from "@/components/politics/Header";
import Footer from "@/components/politics/Footer";

export default function PrivacyPage() {
  const [content, setContent] = useState("");
  const [updatedAt, setUpdatedAt] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    document.title = "Política de Privacidade — RSMNet.work";
    const apiUrl = process.env.REACT_APP_BACKEND_URL;
    fetch(`${apiUrl}/api/privacy`)
      .then((r) => r.json())
      .then((d) => {
        setContent(d.content || "");
        setUpdatedAt(d.updated_at || null);
      })
      .catch(() => setContent("# Política de Privacidade\n\nNão foi possível carregar o conteúdo."))
      .finally(() => setLoading(false));
  }, []);

  return (
    <main
      data-testid="privacy-page"
      className="min-h-screen bg-[#F5FAFB] text-[#1B1D1D]"
    >
      <Header />
      <div className="absolute inset-x-0 top-0 -z-10 h-[480px] rsm-grid-bg opacity-50" />
      <section className="relative pt-32 pb-24">
        <div className="mx-auto max-w-3xl px-6">
          <span className="inline-flex items-center text-xs font-semibold tracking-[0.22em] uppercase text-[#208BFF]">
            Compromisso
          </span>
          <h1 className="mt-3 font-display text-4xl sm:text-5xl font-bold tracking-tighter leading-tight">
            Política de Privacidade
          </h1>
          {updatedAt && (
            <p
              data-testid="privacy-updated-at"
              className="mt-3 text-xs text-[#7D8188]"
            >
              Última atualização:{" "}
              {new Date(updatedAt).toLocaleDateString("pt-BR", {
                day: "2-digit",
                month: "long",
                year: "numeric",
              })}
            </p>
          )}

          <article
            data-testid="privacy-content"
            className="mt-10 rsm-prose"
          >
            {loading ? (
              <p className="text-sm text-[#7D8188]">Carregando…</p>
            ) : (
              <ReactMarkdown>{content}</ReactMarkdown>
            )}
          </article>
        </div>
      </section>
      <Footer />
    </main>
  );
}
